import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
  rows: [],
  loading: false,
  currentDetail: null
};

const setSEOContentData = (state, action) => {
  let seoContentData = action.result;
  
  let updatedState = updateObject(state, {
    rows: seoContentData,
    loading: false
  });
  return updateObject(state, updatedState);
};

const setSEOContentLoading = (state, action) => {
  return updateObject(state, {
    loading: action.loading
  });
};


const getSEOContentById = (state, action) => {
  return updateObject(state, {
    currentDetail: action.data
  });
};

const updateSEOContentInRows = (state, action) => {
  const updatedRows = state.rows.map(row => {
    if (row.work_done_id === action.data.work_done_id) {
      return { ...row, ...action.data };
    }
    return row;
  });

  return updateObject(state, {
    rows: updatedRows
  });
};


function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_SEO_CONTENT_DATA:
      return setSEOContentData(state, action);
    case actionTypes.SEO_CONTENT_LOADING:
      return setSEOContentLoading(state, action);
    case actionTypes.GET_SEO_CONTENT_BY_ID:
      return getSEOContentById(state, action);
    case actionTypes.UPDATE_SEO_CONTENT_IN_ROWS:
      return updateSEOContentInRows(state, action);
    default:
      return state;
  }
}

export default reducer;
